import React, { useEffect, useState, useRef} from "react";
import Header from "../components/Header";
import { BsSearch, BsFillMicFill, BsX, BsCaretUpFill, BsCaretDownFill } from "react-icons/bs";
import { Link, useNavigate, useParams  } from "react-router-dom";
import Product5 from "../components/Product5";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import { useAxios } from "../services/useAxios";
import Autosuggest from "react-autosuggest";
import { useTranslation } from 'react-i18next';

import { splitIntoChunk } from "../services/common";

export default function Search(){
    const { t } = useTranslation();
    
    const {id} = useParams();
    const lang = localStorage.getItem("language") || "ko";
    const [request] = useAxios(); 
    const [keywordList, setKeywordList] = useState([]);
    const [data, setData] = useState({});
    const [searchHistory, setSearchHistory] = useState(sessionStorage.getItem("searchHistory")?JSON.parse(sessionStorage.getItem("searchHistory")):[]);
    const navigate = useNavigate();  
    const [keyword, setKeyword] = useState(id?id:'');
    const [suggestions, setSuggestions] = useState([]);
    const searchInput1 = useRef()

    const fetchData = async () => {
        

        const response = await request.post("/app/goods/getGoodsListAPI", {
            nationSeCode : lang,
            pageUnit : 1000

        });
        if(response.data.resultCode === 200){
            var sourceList = []
            for(var i=0; i<response.data.result.resultList.length;i++){
                var obj = response.data.result.resultList[i];
                sourceList.push(obj.goodsNm);                
                if(obj['tag']){
                    sourceList = sourceList.concat(obj.tag.split(","));
                }		
            }
            sourceList = [...new Set(sourceList)];
            sourceList.sort((a, b) => a.length < b.length ? -1 : 1);     	
            setKeywordList(sourceList)             
        }            
    };

    const fetchData2 = async () => {
        const response = await request.post("/app/home/getSaleeHomeInfoAPI", {gcVO :{
            nationSeCode : lang
        }});
        if(response.data.resultCode === 200){      
            response.data.result.bestSubItemList = splitIntoChunk(response.data.result.bestItemList,3);            
            setData(response.data.result);        
        }            
    };
    useEffect(() => {
        searchInput1.current.focus()
        fetchData()
        fetchData2()
    }, []);


    const fn_delKeyword =  (hdsch) => {
        var kywIndex = searchHistory.indexOf(hdsch);
        if(kywIndex > -1){
            searchHistory.splice(kywIndex, 1) // 같은 검색어 삭제
        }		    
        setSearchHistory(searchHistory.slice(0,5))   
        var keywordListToString = JSON.stringify(searchHistory);
        sessionStorage.setItem('searchHistory', keywordListToString);
    }

    const fn_allDelKeyword =  () => {
        setSearchHistory([])   
        var keywordListToString = JSON.stringify([]);
        sessionStorage.setItem('searchHistory', keywordListToString);
    }
    
    

    const fn_saveKeyword  = (hdsch) => {
        if(hdsch){
            var kywIndex = searchHistory.indexOf(hdsch);
		    if(kywIndex > -1){
                searchHistory.splice(kywIndex, 1) // 같은 검색어 삭제
		    }		    
		    searchHistory.unshift(hdsch);			    
            setSearchHistory(searchHistory.slice(0,5))   
		    //sessionStorage는 string만 저장가능
		    var keywordListToString = JSON.stringify(searchHistory);
		    sessionStorage.setItem('searchHistory', keywordListToString);
        }
    }

   

    

    const onChange = (event, { newValue, method }) => {        
        setKeyword(newValue);
        
    };

    const fn_search = (searchKrwd) =>{
        sessionStorage.setItem("SEARCH_KEYWORD",searchKrwd);
        fn_saveKeyword(searchKrwd)
        navigate('/SearchList/'+searchKrwd)        
    }

    const onKeyDown = (event) => {
        if(event.key === "Enter" && keyword) {
            fn_search(keyword)
        }
    }
    const onSuggestionsFetchRequested = ({ value }) => {        
        setSuggestions(() => getSuggestions(value));
    };

    const onSuggestionsClearRequested = () => {
        console.log("clear")
        setSuggestions([]);
    };

    const onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) =>{        
        fn_search(suggestionValue)        
    };

    const inputProps = {
        placeholder: t(`Message.search_input_msg`),        
        value: keyword,
        onChange: onChange,
        onKeyDown :onKeyDown,
        ref : searchInput1
    };

    const getSuggestions = (value) => {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        return inputLength === 0
        ? []
        : keywordList.filter(
            (lang) => lang.indexOf(inputValue)===-1?false:true
            );
    };

    const getSuggestionValue = (suggestion) => suggestion;

    const renderSuggestion = (suggestion) => (
        <div>{suggestion}</div>
    );

    return (
        <div>
            <div className="backGround bgBlue"></div>
            <Header type="cart" handleBack={(e) => navigate("/") } pageTitle={t(`Message.common_bottom_navigation_bar_search`)}/>

            <div className="schPageArea">
                <div className="mainSchWr">
                    <BsSearch className="schIcon"/>
               
                    <Autosuggest
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={onSuggestionsClearRequested}
                        getSuggestionValue={getSuggestionValue}
                        renderSuggestion={renderSuggestion}
                        onSuggestionSelected = {onSuggestionSelected}
                        inputProps={inputProps}         
                        theme={{
                            container :'searchAuto',
                            input:                    'saInput',
                            inputFocused:             'saFocus',
                            suggestionsContainer:     'saListWr',
                            suggestionsContainerOpen: 'saOpen',
                            suggestionsList:          'saList',
                        }}             
                    />
                    <button 
                        type="button" 
                        className="micIcon"
                        onClick={(e) => {
                            e.preventDefault(); 
                            e.stopPropagation();
                    }}>
                        <BsFillMicFill/>
                    </button>
                </div>

                {searchHistory && searchHistory.length !== 0?(
                <div className="recentSch schContArea">
                    <div className="rshead">
                        <p className="schTit">{t(`Message.latest_search_keyword_title`)}</p>
                        <button type="button" className="schDel" onClick={fn_allDelKeyword}>{t(`Message.latest_search_keyword_all_remove`)}</button>
                    </div>
                    <ul className="recentList">
                        {searchHistory.map((obj, index) => (   
                        <li className="recentWord" key={index} >
                            <button type="button" className="txt" onClick={(e) => {fn_search(obj)}}>{obj}</button>
                            <button type="button" className="del" onClick={(e)=> fn_delKeyword(obj)}><BsX /></button>
                        </li>
                        ))}                         
                    </ul>
                </div>
                ):null}

                <div className="schProdList schContArea">
                    <p className="schTit">SALEE BEST ITEM</p>
                    <div className="pls">
                        <Swiper 
                            className="pb30"                            
                            slidesPerView={1.12}
                            spaceBetween={30}
                            autoplay={false}
                            loop = "true"                            
                            pagination={{ clickable: true }}
                        >
                            {data.bestSubItemList && data.bestSubItemList.map((bestItem, index) => (
                            <SwiperSlide key={index}>
                            {bestItem && bestItem.map((obj, index2) => (
                                <Product5 key={index2}
                                    type="type13"
                                    grad={(index2+1)+(3*index)}
                                    prodName={obj.goodsNm}
                                    img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                                    buy={obj.orderCnt}
                                    disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                                    percent={Math.round((!obj.dscntRate?0:obj.dscntRate) * 100)}
                                    cost={"￦"+(!obj.nrmltAmount?0:obj.nrmltAmount).toLocaleString('ko-KR')}
                                    heart
                                    cart
                                    obj = {obj}
                                />
                            ))}         
                            </SwiperSlide>                
                             ))}    
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
};